import { useParams } from 'react-router-dom';
import SimpleBreadcrumbsPage from '../../../../shared/simple-breadcrumbs-page';
import { ModuleList } from '../../../../shared/analytics/module-list';
import { pagesConfig } from '../../../../shared/pages-config';
import GroupTemplateFormLayout from '../create-template/group-template-form-layout';

export default function EditGroupTemplatePage() {
  const { id } = useParams();

  return (
    <SimpleBreadcrumbsPage
      isSubPage
      breadcrumbs={[
        { label: ModuleList.modules.directory.name },
        {
          label: pagesConfig.groupTemplates.name,
          path: pagesConfig.groupTemplates.link,
        },
      ]}
    >
      {/* Keyed by id so moving between templates starts from a fresh form. */}
      <GroupTemplateFormLayout
        key={id}
        title={pagesConfig.editGroupTemplate.name}
        pageMode="edit"
      />
    </SimpleBreadcrumbsPage>
  );
}
